




























    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import CreateWasteType from './create-wastetype.vue'
    import EditWasteType from './edit-wastetype.vue'
   
    class PagewastetypeRequest extends PageRequest{
        keyword:string='';
    }
    
    @Component({
        components:{CreateWasteType,EditWasteType}
    })
    export default class wastetypes extends AbpBase{
        edit(){
            this.editModalShow=true;
        }

        pagerequest:PagewastetypeRequest=new PagewastetypeRequest();

        createModalShow:boolean=false;
        editModalShow:boolean=false;
        get list(){
            
            return this.$store.state.wastetype.list;
        };
        get loading(){
            return this.$store.state.wastetype.loading;
        }
        create(){
            this.createModalShow=true;
        }
        pageChange(page:number){
            this.$store.commit('wastetype/setCurrentPage',page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit('wastetype/setPageSize',pagesize);
            this.getpage();
        }
        async getpage(){
            
            this.pagerequest.maxResultCount=this.pageSize;
            this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
            
            await this.$store.dispatch({
                type:'wastetype/getAll',
                data:this.pagerequest
            })
        }
        get pageSize(){
            return this.$store.state.wastetype.pageSize;
        }
        get totalCount(){
            return this.$store.state.wastetype.totalCount;
        }
        get currentPage(){
            return this.$store.state.wastetype.currentPage;
        }
        columns=[    {
　　width: 80, align: 'center', title: '序号', render: (h, params) => {
　　　　return h('span', params.index + (this.currentPage - 1) * this.pageSize + 1);
　　}
},{
            title:this.L('WasteTypeName'),
            key:'wdname'
        } 
       ,{
            title:this.L('Actions'),
            key:'Actions',
            width:150,
            render:(h:any,params:any)=>{
                return h('div',[
                    h('Button',{
                        props:{
                            type:'primary',
                            size:'small'
                        },
                        style:{
                            marginRight:'5px'
                        },
                        on:{
                            click:()=>{
                                this.$store.commit('wastetype/edit',params.row);
                                this.edit();
                            }
                        }
                    },this.L('Edit')),
                    h('Button',{
                        props:{
                            type:'error',
                            size:'small'
                        },
                        on:{
                            click:async ()=>{
                                this.$Modal.confirm({
                                        title:this.L('Tips'),
                                        content:this.L('DeleteConfirm'),
                                        okText:this.L('Yes'),
                                        cancelText:this.L('No'),
                                        onOk:async()=>{
                                            await this.$store.dispatch({
                                                type:'wastetype/delete',
                                                data:params.row
                                            })
                                            await this.getpage();
                                        }
                                })
                            }
                        }
                    },this.L('Delete'))
                ])
            }
        }]
         async created(){
            this.getpage();
            
        }
        
    }
